import type { DataOption } from '@/common.types'
import type {
	PricingCampaignModel,
	PricingEngineType,
} from '@/shared/generated'

import { negate, orderBy } from 'lodash/fp'

import { getPricingCampaignEngine, isGlobalPricingCampaign } from './helpers'

export const pcToOption = (
	item: PricingCampaignModel
): DataOption & { engine: PricingEngineType } => ({
	label: item.name,
	engine: getPricingCampaignEngine(item),
	value: item.id,
})

export const alignPricingCampaignsOrders = (
	data: PricingCampaignModel[]
): PricingCampaignModel[] => {
	// Separate global and local PC
	const global = orderBy(
		['order'],
		['asc'],
		data.filter(isGlobalPricingCampaign)
	)
	// Separate global and local PC
	const local = orderBy(
		['order'],
		['asc'],
		data.filter(negate(isGlobalPricingCampaign))
	)

	// Assign order to each PC to avoid conflicts
	return [...global, ...local].map((pc, index) => ({
		...pc,
		order: index + 1,
	}))
}
